"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCustomerPartNumber = exports.determineProductDisplay = exports.navigateToProductDetails = void 0;

var navigateToProductDetails = function navigateToProductDetails(productUrl, altPartNumber, storeDirectory) {
  var url = storeDirectory ? storeDirectory : "";
  url += "/products/".concat(productUrl);
  var isExistingParams = productUrl === null || productUrl === void 0 ? void 0 : productUrl.search("&");
  var queryParam = isExistingParams === -1 ? "?" : "&";
  var altPartParam = "altPartNumber=".concat(altPartNumber);
  return "".concat(url).concat(queryParam).concat(altPartNumber ? altPartParam : "");
};

exports.navigateToProductDetails = navigateToProductDetails;

var determineProductDisplay = function determineProductDisplay(altNumber, fastPath) {
  if ((altNumber === null || altNumber === void 0 ? void 0 : altNumber.slice(0, 3)) === "CPN") {
    return altNumber;
  } else {
    return fastPath;
  }
};

exports.determineProductDisplay = determineProductDisplay;

var renderCustomerPartNumber = function renderCustomerPartNumber(fastPath, partNumber, altPartNumber, sku) {
  if (!partNumber && !altPartNumber && !fastPath) {
    return sku;
  } else {
    return (partNumber === null || partNumber === void 0 ? void 0 : partNumber.length) ? "CPN: ".concat(partNumber) : (0, exports.determineProductDisplay)(altPartNumber, fastPath || "");
  }
};

exports.renderCustomerPartNumber = renderCustomerPartNumber;